import {} from "@siteimprove/alfa-predicate";
import {} from "../../node.js";
import {} from "../../role.js";
import { hasName } from "../../role/predicate/has-name.js";
export function hasRole(nameOrPredicate = () => true, ...names) {
    let predicate;
    if (typeof nameOrPredicate === "function") {
        predicate = nameOrPredicate;
    }
    else {
        predicate = hasName(nameOrPredicate, ...names);
    }
    return (node) => node.role.some(predicate);
}
//# sourceMappingURL=has-role.js.map